import { isBefore } from "date-fns";
import { Event } from "../../../../context/eventsContext/reducer";

const EventLocation = (props: {
  event: Event
}) => {
  if(!props.event.location) return (<></>);

  const textColor = () => {
    if(!props.event.date) return false;
    const inPast = isBefore(new Date(props.event.date.replace(/-/g, '\/')), new Date());
    
    return inPast ? "text-gray-400" : "text-gray-700";
  }

  return (
    <div className={`w-full flex text-gray-400 ${ textColor() }`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 mr-2 ignore"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
      <p>{props.event.location}</p>
    </div>
  )
}

export default EventLocation;